import React from 'react';
import { RedirectingStyle } from './styled';
import { images } from '../../../Constants/ImageUrls';

function RedirectScreen() {
  return (
    <RedirectingStyle>
      <img src={images?.loadingIcon} alt="Loading" />
      <p>Redirecting...</p>
    </RedirectingStyle>
  );
}

export default RedirectScreen;
